import { EnumSchema } from '../metadata-schema';

export const EerderGeexamineerd: EnumSchema = {
	"type": "string",
	"title": "EerderGeexamineerd",
	"enum": [
		"Voorlaatste jaar",
		"Gespreid examen"
	]
};
